export const getReportTitle = (dashboardName, dashboardEntityName) => {
    let title = dashboardName;
    if (dashboardEntityName) {
        title += `: ${dashboardEntityName}`;
    }
    return title;
};
export const getReportFileName = (dashboardName, reportTitle, reportAsOf) => {
    const date = new Date();
    let reportFileName = `${dashboardName}-${reportTitle}-${reportAsOf}-${`${date.getDay()}_${date.getMonth() + 1}_${date.getFullYear()}`}`;
    reportFileName = reportFileName.replaceAll(/[|&;$%@"<>()+,.:]/gu, "_");
    reportFileName = reportFileName.replaceAll(" ", "_");
    reportFileName = reportFileName.replaceAll("__", "_");
    return reportFileName;
};
export const getAnalysisSections = (entity, sections) => {
    const urlPart = window.location.href.split("/");
    const result = sections?.map((section) => ({
        id: section.id,
        isSelected: false,
        name: section.name,
        url: `${urlPart[0]}//${urlPart[2]}/${entity.toLowerCase()}/${urlPart[4]}/${section?.id}`
    }));
    return result;
};
